<template>
  <report-data-provider :requiredReports="requiredReports" v-model="reports" v-slot:default="{ loading, error, retry }">
    <card-loading v-if="loading" />
    <card-reload v-else-if="error" @reload="retry()"/>
    <div v-else class="chart-card">

      <div class="flex flex-column">
        <div>
          <h1 class="f5 f4-l fw5 ma0 pa0 lh-title text-primary">
            {{ title }}
          </h1>
          <span class="db f6 f5-l ma0 pa0 lh-title text-secondary">
            {{ subtitle }}
          </span>
        </div>
      </div>

      <div class="flex flex-column mt5">
        <div class="mv3 flex flex-column">
          <div class="fw6">Полученная экономия,</div>
          <span class="mv1 legend-line" :style="'border-left-color: ' + economicEffect.result.color + ';'"></span>
          <div class="tr flex justify-between pv1">
            <div>
              <span class="fw6">{{ economicEffect.result.percent }}</span>
              <span class="text-secondary ml1">%</span>
            </div>
            <div>
              <span class="text-secondary mr2">{{ economicEffect.unit }}</span>
              <span class="fw6">{{ economicEffect.result.value.toLocaleString('ru-RU') }}</span>
            </div>
          </div>
        </div>
        <div class="mv3 flex flex-column">
          <div class="">Возможная экономия</div>
          <span class="mv1 legend-line" :style="'border-left-color: ' + economicEffect.possible.color + ';'"></span>
          <div class="tr pv1">
            <span class="text-secondary mr2">{{ economicEffect.unit }}</span>
            <span class="fw6">{{ economicEffect.possible.value.toLocaleString('ru-RU') }}</span>
          </div>
        </div>
      </div>
    </div>
  </report-data-provider>
</template>

<script>
import ReportDataProvider from '@/components/dashboard/ReportDataProvider.vue'
import CardLoading from '@/components/dashboard/CardLoading.vue'
import CardReload from '@/components/dashboard/CardReload.vue'
import { senseMap } from '@/plugins/colors.js'
import { formatPercent } from '@/plugins/consts.js'

export default {
  components: {
    ReportDataProvider,
    CardLoading,
    CardReload
  },
  data () {
    return {
      requiredReports: ['economicEfficiency'],
      reports: null,
      title: 'Общий экономический эффект',
      subtitle: 'суммарно за период'
    }
  },
  computed: {
    report () {
      return this.reports.economicEfficiency
    },
    economicEffect () {
      return {
        possible: {
          value: Math.round(this.report.possibleEconomyTotal),
          color: senseMap.planned
        },
        result: {
          value: Math.round(this.report.resultingEconomyTotal),
          percent: formatPercent(this.report.economicEffectPercent),
          color: senseMap.defacto
        },
        unit: 'руб.'
      }
    }
  },
  methods: {
    label (offset) {
      const dates = this.$store.getters['dashboard/dates']
      const dateFormat = this.$store.getters['dashboard/format']
      // % hack для демо режима
      return dates[offset % dates.length].format(dateFormat)
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-card {
  display: flex;
  flex-direction: column;
  justify-items: center;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;
  background-color: #FFFFFF;
  border-radius: .25rem;
  min-width: 270px;
  max-width: 350px;
}
.legend-line {
  width: 100%;
  height: 0;
  border-top-left-radius: 20%;
  border-bottom-left-radius: 20%;
  border-top: 2px solid transparent;
  border-bottom: 2px solid transparent;
  border-left-style: solid;
  border-left-width: 270px;
  overflow: hidden;
}
@media screen and (min-width: 60em) {
  .legend-line {
    width: 100%;
    height: 0;
    border-top-left-radius: 20%;
    border-bottom-left-radius: 20%;
    border-top: 2px solid transparent;
    border-bottom: 2px solid transparent;
    border-left-style: solid;
    border-left-width: 270px;
    overflow: hidden;
  }
}
</style>
